//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CalendarFeedFreeBusyMode } from './Enums';

export class TeacherCalendarFeedPreferencesUpdateItem extends ItemBase {
    AlertBeforeInMinutes?: number;
    FreeBusyEventMode?: CalendarFeedFreeBusyMode;
    FutureMonthsToSynchronize?: number;
    PastMonthsToSynchronize?: number;
    ShowAllTeachers?: boolean;
    SynchronizeBirthdays?: boolean;
    SynchronizeRepertoirePerformances?: boolean;
    EventCategoryIDsToAlert?: string[];

    constructor(initializer?: Partial<TeacherCalendarFeedPreferencesUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherCalendarFeedPreferencesUpdateItem";
}
